import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HashUtils {
  createHash(data: string): string {
    const hash = CryptoJS.HmacSHA256(data, environment.secretHashKey);
    return CryptoJS.enc.Base64.stringify(hash);
  }
}
